import { useDeleteEvent, useGetAllEvents } from "@api/eventService";
import { useEffect, useState } from "react";
import Box from '@mui/joy/Box';
import IconButton from '@mui/joy/IconButton';
import Tooltip from '@mui/joy/Tooltip';
import Typography from '@mui/joy/Typography';
import ObjectIndex from "@components/objects/ObjectIndex";
import LocalPhoneRoundedIcon from '@mui/icons-material/LocalPhoneRounded';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import { formatDate, formatTime, isValidDate } from "@utils/dates";
import { useGetAllProperties } from "@api/propertyService";

import Diversity3RoundedIcon from '@mui/icons-material/Diversity3Rounded';
import DirectionsRoundedIcon from '@mui/icons-material/DirectionsRounded';
import { sortByDate } from "@utils/sorters";
import { onlyFutureDates } from "@utils/filters";
import { EventDate } from "@components/EventDate";

const columns = [
    {
        id: 'name',
        numeric: false,
        disablePadding: true,
        sortable: true,
        label: 'Name',
        cell: (row, {LinkComponent}) => {
            return (<>
                <LinkComponent to={`${row.id}`} relative={true} object={row}>
                    <Typography sx={{display: 'inline-block'}} fontWeight={'bold'}>
                        {row.name}
                        {!!row.opportunities.length && <Diversity3RoundedIcon sx={{ml: '0.25rem', transform: 'translateY(0.125rem)'}}/>}
                    </Typography>
                </LinkComponent>

                {row.description && (<Typography fontSize="xs">{row.description}</Typography>)}
            </>)
        }
      },
      /*
      {
        id: 'description',
        numeric: false,
        disablePadding: false,
        sortable: false,
        label: 'Description',
        cell: (row, {LinkComponent}) => {
            return <Typography fontSize={'xs'}>{row.description}</Typography>;
        }
      },
      */
      {
        id: 'category',
        numeric: false,
        disablePadding: false,
        sortable: false,
        label: 'Category',
        cell: (row, {LinkComponent}) => {
            return row?.category?.name ?? 'N/A';
        }
      },
      {
        id: 'location',
        numeric: false,
        disablePadding: false,
        sortable: true,
        label: 'Location',
        cell: (row, {LinkComponent}) => {
            return row.location;
        }
      },
      {
        id: 'event_date',
        numeric: false,
        disablePadding: false,
        sortable: true,
        label: 'Upcoming Dates',
        cell: (row, {LinkComponent}) => {
            const upcomingDates = row.dates.sort((a, b) => sortByDate(a, b, 'start_date'));
            const filteredDates = onlyFutureDates(upcomingDates, 'start_date', true);

            if(!filteredDates.length) {
                return <em>No upcoming dates</em>
            }

            return (<>
                {filteredDates.map((date, dateIndex) => {
                    return <EventDate date={date}/>;
                })}
            </>);
        }
      },
];

const listCell = (row, {LinkComponent}) => {
    const upcomingDates = row.dates.sort((a, b) => sortByDate(a, b, 'start_date'));
    const filteredDates = onlyFutureDates(upcomingDates, 'start_date', true).splice(0, 2);

    return (<>
        <Box sx={{mb: 1}}>
            <Typography sx={{display: 'inline-block'}} fontWeight={'bold'}>
                <LinkComponent to={`${row.id}`} relative={true} object={row}>
                    {row.name}
                </LinkComponent>
            </Typography>
            <Typography fontSize="sm">
                <Typography fontWeight={'bold'}>Location</Typography>
                {' '}
                {row.location}
            </Typography>

            <Typography fontSize="sm">
                <Typography fontWeight={'bold'}>Upcoming Dates</Typography>
                {' '}
                {filteredDates.map((date, dateIndex) => {
                    return <EventDate date={date}/>;
                })}
            </Typography>
        </Box>
    </>);
};

/*
const listActions = (row, {view, LinkComponent, ViewAction}) => {
    if(view === 'deleted') {
        return null;
    }

    const destination = `${row.address} ${row.city} ${row.state_province}`;

    return (<>
        <Tooltip title="Get Directions">
            <IconButton
                size="sm"
                color="neutral"
                variant="outlined"
                sx={{ bgcolor: 'background.surface', ":disabled": {opacity: 0.3} }}
                disabled={!row.email}
                component={'a'}
                href={`https://www.google.com/maps/dir/?api=1&destination=${destination}`}
                target="_blank"
                >
                <DirectionsRoundedIcon />
            </IconButton>
        </Tooltip>
    </>);
};
*/

export default function EventIndex() {
    return (
        <ObjectIndex
            query={useGetAllEvents}
            deleteMutation={useDeleteEvent}
            type={'event'}
            permissionType={'events'}
            title={'Events'}
            color={'event'}
            columns={columns}
            listCell={listCell}
            // listActions={listActions}
        />
    )
}
